import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Homepage from './components/Homepage';
import PromptGenerator from './components/PromptGenerator';
import ImageUpload from './components/ImageUpload';
import { useImageGeneration } from './hooks/useImageGeneration';
import './App.css';

function App() {
  const [referenceImages, setReferenceImages] = useState<string[]>([]);
  const { generatedImages, isGenerating, generateFromPrompt, clearImages, deleteImage, imageCount } = useImageGeneration();

  const handleGenerateImages = useCallback(async (prompt: string, refImages: string[]) => {
    await generateFromPrompt(prompt, refImages);
  }, [generateFromPrompt]);

  const handleUploadImages = useCallback((images: string[]) => {
    setReferenceImages(images);
    console.log('User uploaded', images.length, 'reference images');
  }, []);

  const handleGenerateSticker = useCallback(async (action: string) => {
    if (referenceImages.length === 0) {
      alert('Please upload a photo first!');
      return;
    }
    await generateFromPrompt(action, referenceImages);
  }, [generateFromPrompt, referenceImages]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <Homepage
                images={generatedImages}
                isGenerating={isGenerating}
                onClearImages={clearImages}
                onDeleteImage={deleteImage}
                imageCount={imageCount}
                onUploadImages={handleUploadImages}
                onGenerateSticker={handleGenerateSticker}
                userPhotos={referenceImages}
              />
            }
          />
          <Route
            path="/:action"
            element={
              <PromptGenerator
                onGenerateImages={handleGenerateImages}
                referenceImages={referenceImages}
                onUploadImages={handleUploadImages}
              />
            }
          />
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
